import { ChangeTitle } from "Components/menu/funciones"
import { useCallback, useState } from "react"
import { useNavigate } from "react-router"
import PromotionDetails from "./PromotionDetails"
import PromotionTable from "./PromotionTable"
// import { PromotionsProvider } from "./contexts/PromotionContext"
import TablaDetalle from "#common/tablaDetalle/TablaDetalle"
import { usePromotionData } from "./hooks/getPromotions"
import { PromotionsProvider } from "./PromotionContext"
const Promotions = () => {
	ChangeTitle("Promociones")
	let navigate = useNavigate()
	const [reload, setReload] = useState(true)
	const { promotions, loading } = usePromotionData(reload)

	const openPromotionDetail = useCallback(
		(PromotionId) => {
			navigate(`${PromotionId}`)
		},
		[navigate],
	)
	return (
		<PromotionsProvider {...{ reloadTable: () => setReload(!reload) }}>
			<TablaDetalle
				Detalle={PromotionsDetails}
				tabla={
					<PromotionTable {...{ promotions, loading }} onClick={openPromotionDetail} />
				}
				title="Promociones"
				key={"promotionsId"}
				nameParam="promotionsId"
				ruta="/promociones"
			/>
			{/* <Animation activar={!promotionsId}>
					<PromotionTable {...{ promotions, loading }} onClick={openPromotionDetail} />
				</Animation>
				<Animation activar={promotionsId}>
					<PromotionsDetails promotionsId={promotionsId} />
				</Animation> */}
		</PromotionsProvider>
	)
}

export default Promotions

const PromotionsDetails = ({ promotionsId }) => {
	const [promotionReload, setPromotionReload] = useState(true)

	return (
		<PromotionDetails
			promotionId={promotionsId}
			reload={() => setPromotionReload(!promotionReload)}
		/>
	)
}
